import React, { useState, useEffect } from "react";
import {
    Tittle,
    SearchProduct,
    ProductContainer,
    ErrMsgContainer
} from './ProductOfTheWeekManagement.style'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'
import Form from "react-bootstrap/Form";
import ProductOfTheWeekCart from './../../components/ProductOfTheweekCart/ProductOfTheWeekCart';
import API from "../../network/dashboardAPI";
import { set } from "lodash";


export const ProductOfTheWeekManagement = (data) => {

    const [showModal, setShowModal] = useState(false)
    const [productId, setProductId] = useState('')
    const [searchItem, setSearchItem] = useState('')
    const [item, setItem] = useState('')
    const [errMsg, setErrMsg] = useState('')

    const getAdminProductOfTheWeek = () => {
        API.getAdminProductOfTheWeek({})
        .then((res) => res.json())
        .then((res) => {
            if(res.success){
                setItem(res.data[0].store_item_info)
            }
        })        
    }
    useEffect(() =>{
        getAdminProductOfTheWeek();
    },[])


    const handleProductIdInput = (e) => {
        e.preventDefault();
        setProductId(e.target.value)
    }
    const handlSearchProduct = (e) => {
        e.preventDefault();
        if(productId !== ''){
            API.getProductByID({item_id: productId})
            .then((res) => res.json())
            .then((res) => {
                if(res.success && res.data !== null){
                    setSearchItem(res.data)
                    setErrMsg('')
                }else{
                    setSearchItem('')
                    setErrMsg('Product is not found!')
                }
            })
        }
    }
    const handleCloseModel = (e) => {
        setSearchItem('')
        setErrMsg('')
        setProductId('')
        setShowModal(false)
    }
    const handleUpdateProduct = (e) => {
        e.preventDefault()
        if(searchItem.item_id !== ''){
            API.updateAdminProductOfTheWeek({
                new_item_id: searchItem.item_id,
            }).then((res) => res.json())
            .then((res) => {
                if(res.success){
                    alert(res.message)
                    handleCloseModel()
                    getAdminProductOfTheWeek();
                }
            })
        }
    }

    return (
        <>
            <Button variant="success" onClick={(e) => setShowModal(true)}>Update Product</Button>
            {item !== '' && 
                <ProductContainer>
                    <ProductOfTheWeekCart product={item}/>
                </ProductContainer>
            }
            

            <Modal show={showModal} onHide={(e) => handleCloseModel(e)}>
                <Modal.Header closeButton>
                    <Modal.Title>Update product of the week</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <SearchProduct>
                        <Form.Control
                            style={{ width: "70%" }}
                            size="md"
                            type="text"
                            value={productId}
                            placeholder="Search Product by ID"
                            onChange={(e) => handleProductIdInput(e)}
                        />
                        <Button onClick={(e) => handlSearchProduct(e)}>Search</Button>
                    </SearchProduct>

                    {
                        searchItem !== '' ? (
                            <ProductOfTheWeekCart product={searchItem}/>
                        ):(null)
                    }
                    {errMsg !== '' ? (
                        <ErrMsgContainer>{errMsg}</ErrMsgContainer>
                    ): null
                    }

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={(e) => handleCloseModel(e)}>
                    Close
                    </Button>
                    <Button variant="primary" onClick={(e) => handleUpdateProduct(e)}>
                       Update
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}